import styled from "styled-components";

export const CurrencyAmountCurrencyBox = styled.div`
    background: none;
    border-right: 2px solid ${({theme}) => theme.colors.boxBorderContrast};
    padding: 5px 15px;
    flex-grow: 0;
    @media ${({theme}) => theme.mediaQuery.xs} {
      max-width: 280px;
    }
`;